/**
 * Use the same `libraries` value for every `useLoadScript` on a screen that also
 * mounts `AddressAutocomplete` (Places). If one hook omits `places` and another
 * includes it, the loader can swap the Maps script URL and leave `GoogleMap` on a
 * blank gray canvas.
 */
export const GOOGLE_MAPS_SCRIPT_LIBRARIES: ("places")[] = ["places"];
